import request from '@/utils/request'

// export function generateDiagram (protocol_id) {
//   request.defaults.timeout = 180000;
//   return request({
//     url: '/protocol_detail/graph/' + protocol_id,
//   }).finally( () =>  { request.defaults.timeout = 5000 })
// }


export function generateDiagram (protocol_id) {
    request.defaults.timeout = 180000;
    return request({
        url: '/protocol_detail/graph/' + protocol_id,
        method: 'get',
        responseType: 'blob',
    }).then( response => {
  
        var newBlob = new Blob([response], {type: "application/pdf"});
        var fileURL = window.URL.createObjectURL(newBlob, { oneTimeOnly: true });
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'emn_diagram.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
  
        // let tab = window.open(); 
        // tab.location.href = fileURL;
  
    })
    .finally( 
        //issue 272
        () =>  { request.defaults.timeout = 180000 }
        //issue 272
    )
  }